import { render, staticRenderFns } from "./ModalMessages.vue?vue&type=template&id=3caae127&scoped=true&"
import script from "./ModalMessages.vue?vue&type=script&lang=ts&"
export * from "./ModalMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMessages.vue?vue&type=style&index=0&id=3caae127&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caae127",
  null
  
)

export default component.exports